import VueI18n from 'vue-i18n';

const messages = {
  ja: {
    menu: {
      activity: 'アクティビティ',
      dashboard: 'ダッシュボード',
      sensors: 'センサー',
      station: 'S型',
      r_type: 'ネズミ',
      information: 'インフォメーション',
      mirakun_device: '自動投薬機',
      sensor_list: 'センサー一覧',
      account_list: 'アカウント一覧',
      organization_list: '組織一覧',
      account: 'アカウント情報',
      logout: 'ログアウト',
      organization: '組織情報',
    },
  },
  en: {
    menu: {
      activity: 'Activity',
      dashboard: 'Dashboard',
      sensors: 'Sensors',
      station: 'S-type',
      r_type: 'Rodents',
      information: 'Information',
      mirakun_device: 'Chemical treatment system',
      sensor_list: 'Sensor List',
      account_list: 'Account List',
      organization_list: 'Organization List',
      account: 'Account',
      logout: 'Log out',
      organization: 'Organization',
    },
  },
};

const i18n = new VueI18n({ locale: 'en', messages });

// R 型タブは、ネズミ検知の 2 系統のいずれかを利用していれば表示する。
const R_TYPE_PERMISSIONS = ['rat_monitor', 'rat_sense'];

export default {
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    userName() {
      return this.currentUser.name;
    },
    isDistributor() {
      return !!this.currentUser.distributor;
    },
    accountPath() {
      // 代理店は管理画面にいても、一般ユーザーと同じアカウント画面を使う
      if (this.isDistributor) {
        return '/account';
      }
      return this.admin ? `/admin/accounts/${this.currentUser.email}` : '/account';
    },
    organizationPath() {
      return this.admin ? `/admin/organizations/${this.currentUser.owner_id}` : '/organization';
    },
    accountLabel() {
      return i18n.t('menu.account', this.$i18n.locale);
    },
    organizationLabel() {
      return i18n.t('menu.organization', this.$i18n.locale);
    },
    logoutLabel() {
      return i18n.t('menu.logout', this.$i18n.locale);
    },
    items() {
      if (this.admin || this.isDistributor) {
        return [
          { title: i18n.t('menu.sensor_list', this.$i18n.locale), path: '/admin/sensors' },
          { title: i18n.t('menu.organization_list', this.$i18n.locale), path: '/admin/organizations' },
          { title: i18n.t('menu.account_list', this.$i18n.locale), path: '/admin/accounts' },
        ];
      }

      const canSeeSType = this.$store.getters.hasPermission('station');
      const canSeeFS = this.$store.getters.hasPermission('fly_scan');
      const canSeeMirakunDevice = this.$store.getters.hasPermission('mirakun_device') &&
            this.currentUser.mirakun_user_id;
      const canSeeRType = R_TYPE_PERMISSIONS
        .some(permission => this.$store.getters.hasPermission(permission));

      return this._.compact([
        { title: i18n.t('menu.activity', this.$i18n.locale), path: '/activities' },
        canSeeFS && { title: i18n.t('menu.dashboard', this.$i18n.locale), path: '/dashboard' },
        canSeeRType && { title: i18n.t('menu.r_type', this.$i18n.locale), path: '/r_type_places' },
        canSeeSType && { title: i18n.t('menu.station', this.$i18n.locale), path: '/station' },
        canSeeMirakunDevice && { title: i18n.t('menu.mirakun_device', this.$i18n.locale), path: '/mirakun_device' },
        { title: i18n.t('menu.sensors', this.$i18n.locale), path: '/sensors' },
        { title: i18n.t('menu.information', this.$i18n.locale), path: '/information' },
      ]);
    },
    isSignedInAsAnotherUser() {
      return !!this.$store.getters.assumedUser;
    },
    isPartOfOrganization() {
      return !!this.currentUser.owner_id;
    },
  },
  inject: ['resetIdentity'],
  methods: {
    signOut: async function () {
      if (this.isSignedInAsAnotherUser) {
        await this.resetIdentity();
        this.$router.push('/admin/accounts');
      } else {
        this.$store.dispatch('signOut');
        this.$router.push('/sign_in');
      }
    },
  },
};
